import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import {
  brandFonts,
  fontSize,
  brandColours,
  visuallyHidden,
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Button, Container, HtmlContent } from './ui';
import SpaEnquiry from './SpaEnquiry';
import { StoreContext } from '../context/StoreContext';

const StyledContentAlert = styled.section`
  ${sectionMargins('22px', '28px')};
`;

const StyledInner = styled.div`
  position: relative;
  color: ${brandColours.primary};
  background-color: ${brandColours.septenary};
  padding: 30px 22px;

  ${minBreakpointQuery.smedium`
    padding: 35px 25px;
  `}

  ${minBreakpointQuery.medium`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 30px;
    padding: 30px 40px;
    align-items: center;
  `}

  ${minBreakpointQuery.mlarge`
    column-gap: 40px;
    padding: 40px 60px;
  `}
`;

const StyledTop = styled.div`
  ${maxBreakpointQuery.medium`
    margin-bottom: 12px;
  `};
`;

const StyledOverline = styled.p`
  ${fontSize(14)};
  line-height: 1.25;
  margin-bottom: 10px;
`;

const StyledHeading = styled.h2`
  ${brandFonts.secondary};
  ${fontSize(40)};
  line-height: 1.25;

  ${minBreakpointQuery.mlarge`
    ${fontSize(45)};
  `}
`;

const StyledButton = styled(SpaEnquiry)`
  margin-top: 20px;

  ${minBreakpointQuery.medium`
    grid-column: 2;
  `}
`;

const StyledClose = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  padding: 18px 20px;

  &:before {
    content: '✕';
    color: ${brandColours.primary};
    ${fontSize(26)};
  }

  span {
    ${visuallyHidden()};
  }
`;

const ContentAlert = ({ heading, subheading, text, enquiryButtonEnabled }) => {
  const { setOverlayActive } = useContext(StoreContext);
  const [openAlert, setOpenAlert] = useState(true);
  const [isSpaEnquiryOpen, setSpaEnquiryOpen] = useState();

  const toggleSpaEnquiryOpen = () => {
    setOverlayActive(!isSpaEnquiryOpen);
    setSpaEnquiryOpen(!isSpaEnquiryOpen);
  };

  return (
    openAlert && (
      <StyledContentAlert>
        <Container>
          <StyledInner>
            <StyledTop>
              <StyledOverline>
                {subheading || 'Important Advice'}
              </StyledOverline>
              <StyledHeading>{heading}</StyledHeading>
            </StyledTop>
            <HtmlContent html={text} />
            {enquiryButtonEnabled && (
              <StyledButton
                toggleSpaEnquiryOpen={toggleSpaEnquiryOpen}
                isSpaEnquiryOpen={isSpaEnquiryOpen}
                isButton={true}
              />
            )}
            <StyledClose onClick={() => setOpenAlert(false)}>
              <span>Close</span>
            </StyledClose>
          </StyledInner>
        </Container>
      </StyledContentAlert>
    )
  );
};

export default ContentAlert;
